module.exports = __webpack_public_path__ + "img/picture2.33314866.png";